import { SchoolContextType } from '@/App/type'
import {
  lastSetXTokenTimeStorage,
  reflectionStorage,
  store,
  xRbacTokenStorage,
} from '@/store'
import { moment } from '@seiue/moment'
import { Button, Form, Toast } from '@seiue/ui'
import { User, authApi } from 'packages/sdks-next/growp'
import { useState } from 'react'
import styled from 'styled-components'

import { VerifyCode } from '../VerifyCode'
import { getFormalUserJumpUrl } from '../user/utils'

/**
 * 二次校验
 *
 * @param param0 - 参数
 * @param param0.schoolConfig - 学校配置
 * @param param0.setIsSecondCheck - 设置是否是二次验证
 * @param param0.user - 校验用户
 * @returns 组件
 */
export const SecondCheck: React.FC<{
  schoolConfig: SchoolContextType
  setIsSecondCheck: () => void
  user?: User
}> = ({ schoolConfig, setIsSecondCheck, user }) => {
  const [form] = Form.useForm()

  const [reminderId, setReminderId] = useState<string>('')
  const reg = /^(\d{3})\d{6}(\d{2})$/
  const showPhone = user?.phone?.replace(reg, '+86$1******$2') || ''
  const phoneNumber = Number(user?.phone || '')

  const clickCheckButton = async () => {
    try {
      const { data: reflection } = await authApi.secondCheckReminder(
        user?.rid || 0,
        {
          phone: String(phoneNumber),
          password: reminderId,
        }
      )

      Toast.success('登录成功')

      store.set(reflectionStorage, reflection)

      authApi
        .checkDataToken()
        .then(({ data }) => {
          store.set(xRbacTokenStorage, data)
          store.set(lastSetXTokenTimeStorage, moment().toISOString())
        })
        // 不管 checkDataToken 是否成功，都进行下一步界面，不影响主流程
        .finally(() => {
          location.href = getFormalUserJumpUrl(reflection.role)
        })
    } catch (e: any) {
      const { data } = e.response
      Toast.error(data?.message)
      // 验证失败，回到登录方式选择页
      setIsSecondCheck()
    }
  }

  return (
    <Wrapper>
      <img
        height={32}
        src={schoolConfig?.logo || '/logo.svg'}
      />
      <Title>{'验证身份'}</Title>
      <Info>{'为了保护您的账号安全，需要二次验证登录'}</Info>
      <DescWrapper>
        请输入发送至 <PhoneWrapper>{showPhone}</PhoneWrapper> 的 4
        位验证码，有效期 5 分钟
      </DescWrapper>

      <Form
        name="msgcheck"
        form={form}
      >
        <StyledFormItem
          rules={[{ required: true, message: '请输入验证码' }]}
          dependencies={[]}
        >
          {() => {
            return (
              <VerifyCode
                phoneNumber={phoneNumber}
                onChange={(val) => setReminderId(val)}
                value={reminderId}
                disabled={!phoneNumber}
              />
            )
          }}
        </StyledFormItem>

        <StyledButton
          type="primary"
          onClick={clickCheckButton}
          disabled={reminderId.length !== 4}
        >
          {'下一步'}
        </StyledButton>
      </Form>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 16px;
  align-self: stretch;
`

const Title = styled.div`
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  height: 32px;
  width: 100%;
  margin-top: 24px;
  color: ${(props) => props.theme.text._1};
`

const Info = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  height: 24px;
  color: ${(props) => props.theme.text._1};
`

const DescWrapper = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-align: center;
  color: ${(props) => props.theme.text._3};
`

const PhoneWrapper = styled.span`
  font-weight: 600;
  color: ${(props) => props.theme.text._1};
`

const StyledFormItem = styled(Form.Item)`
  width: 336px;
  &&& {
    .ant-input-affix-wrapper {
      border: 1px solid transparent !important;
    }
    .ant-input {
      background-color: transparent !important;
    }
    .ant-input-affix-wrapper-focused {
      background-color: transparent !important;
      border: 1px solid ${(props) => props.theme.brand._1} !important;
    }
  }
`

const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 48px;
  &&& {
    height: 40px;
  }
`
